export const trTR = {
  common: {
    search: "Ara...",
    create: "Yeni",
    new: "Yeni",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    theme: "Tema",
    signOut: "Çıkış Yap",
    noMatches: "Eşleşme bulunamadı",
    tryDifferentSearch: "Farklı bir arama terimi deneyin.",
    light: "Açık",
    dark: "Koyu",
    system: "Sistem",
    loading: "Yükleniyor...",
    note: "Not",
    insight: "İçgörü",
    newSource: "Yeni Kaynak",
    newNotebook: "Yeni Defter",
    newPodcast: "Yeni Podcast",
    language: "Dil",
    english: "English",
    chinese: "简体中文",
    japanese: "日本語",
    french: "Français",
    russian: "Русский",
    bengali: "বাংলা",
    catalan: "Català",
    spanish: "Español",
    german: "Deutsch",
    polish: "Polski",
    turkish: "Türkçe",
    source: "Kaynak",
    notebook: "Defter",
    podcast: "Podcast",
    quickActions: "Hızlı eylemler",
    quickActionsDesc: "Gezinme, arama, sor, tema",
    appName: "Open Notebook",
    add: "Ekle",
    remove: "Kaldır",
    confirm: "Onayla",
    warning: "Uyarı",
    error: "Hata",
    success: "Başarılı",
    model: "Model",
    back: "Geri",
    next: "İleri",
    done: "Tamam",
    processing: "İşleniyor...",
    creating: "Oluşturuluyor...",
    linked: "Bağlı",
    adding: "Ekleniyor...",
    addSelected: "Seçilenleri Ekle",
    customModel: "Özel Model",
    failed: "başarısız",
    current: "Mevcut",
    save: "Kaydet",
    writeNote: "Not Yaz",
    batchMode: "Toplu Mod",
    optional: "İsteğe Bağlı",
    type: "Tür",
    title: "Başlık",
    created: "{time} oluşturuldu",
    updated: "{time} güncellendi",
    actions: "Eylemler",
    noResults: "Sonuç yok",
    references: "Referanslar",
    refreshPage: "Lütfen sayfayı yenilemeyi deneyin",
    refresh: "Yenile",
    aiGenerated: "Yapay Zeka Üretimi",
    human: "İnsan",
    unknown: "Bilinmiyor",
    notes: "Notlar",
    chat: "Sohbet",
    deleteForever: "Kalıcı Olarak Sil",
    connectionError: "Bağlantı Hatası",
    unableToConnect: "API sunucusuna bağlanılamıyor",
    retryConnection: "Bağlantıyı Yeniden Dene",
    diagnosticInfo: "Tanılama Bilgisi",
    version: "Sürüm",
    built: "Derlendi",
    apiUrl: "API URL",
    frontendUrl: "Arayüz URL",
    checkConsoleLogs: "Ayrıntılı günlükler için tarayıcı konsolunu kontrol edin (🔧 [Config] mesajlarına bakın)",
    yes: "Evet",
    no: "Hayır",
    saving: "Kaydediliyor...",
    description: "Açıklama",
    saveToNote: "Nota kaydet",
    copyToClipboard: "Panoya kopyala",
    close: "Kapat",
    insights: "İçgörüler",
    progress: "İlerleme",
    deleting: "Siliniyor...",
    created_label: "Oluşturuldu",
    updated_label: "Güncellendi",
    download: "İndir",
    saveChanges: "Değişiklikleri Kaydet",
    name: "Ad",
    default: "Varsayılan",
    nameRequired: "Ad gereklidir",
    modelConfiguration: "Model Yapılandırması",
    resetToDefault: "Varsayılana Sıfırla",
    reasoning: "Akıl Yürütme",
    searchTerms: "Arama Terimleri",
    strategy: "Strateji",
    individualAnswers: "Bireysel Yanıtlar ({count})",
    finalAnswer: "Son Yanıt",
    notebookLabel: "Defter: {name}",
    itemNotFound: "Bu {type} bulunamadı",
    accessibility: {
      transformationViews: "Dönüşüm görünümleri",
      searchKB: "Bilgi tabanınızda sor veya ara",
      enterQuestion: "Bilgi tabanına sormak için sorunuzu girin",
      enterSearch: "Arama sorgusunu girin",
      searchKBBtn: "Bilgi tabanında ara",
      podcastViews: "Podcast görünümleri",
      ytVideo: "YouTube videosu",
      askResponse: "Yanıt",
      searchNotebooks: "Defterlerde ara",
    },
    url: "URL",
    errorDetails: "Hata Ayrıntıları",
    editTransformation: "Dönüşümü Düzenle",
    retry: "Tekrar Dene",
    traditionalChinese: "繁體中文",
    portuguese: "Português",
    completed: "tamamlandı",
    saveSuccess: "Başarıyla kaydedildi",
    contextModes: {
      off: "Sohbete dahil edilmedi",
      insights: "Yalnızca içgörüler",
      full: "Tam içerik",
      clickToCycle: "Geçiş yapmak için tıklayın",
    },
    clickToEdit: "Düzenlemek için tıklayın",
  },
  apiErrors: {
    notebookNotFound: "Defter bulunamadı",
    sourceNotFound: "Kaynak bulunamadı",
    transformationNotFound: "Dönüşüm bulunamadı",
    fileUploadFailed: "Dosya yükleme başarısız",
    urlRequired: "Bağlantı türü için URL gereklidir",
    contentRequired: "Metin türü için içerik gereklidir",
    invalidSourceType: "Geçersiz kaynak türü",
    processingFailed: "İşleme başarısız",
    failedToQueue: "İşleme kuyruğa eklenemedi",
    invalidSortBy: "Sıralama alanı type, title, created, updated, insights_count veya embedded olmalıdır",
    invalidSortOrder: "Sıralama yönü 'asc' veya 'desc' olmalıdır",
    accessDenied: "Dosyaya erişim reddedildi",
    fileNotFoundOnServer: "Sunucuda dosya bulunamadı",
    searchFailed: "Arama başarısız",
    askFailed: "Sorgu başarısız",
    pleaseEnterQuestion: "Lütfen bir soru girin",
    pleaseConfigureModels: "Lütfen gerekli tüm modelleri yapılandırın",
    failedToCreateSession: "Oturum oluşturulamadı",
    failedToUpdateSession: "Oturum güncellenemedi",
    failedToDeleteSession: "Oturum silinemedi",
    failedToSendMessage: "Mesaj gönderilemedi",
    unauthorized: "Yetkisiz erişim, lütfen şifrenizi kontrol edin",
    invalidPassword: "Geçersiz şifre",
    embeddingModelRequired: "Bu özellik için bir gömme modeli gereklidir. Lütfen Modeller bölümünde bir tane yapılandırın.",
    strategyModelNotFound: "Strateji modeli bulunamadı",
    answerModelNotFound: "Yanıt modeli bulunamadı",
    finalAnswerModelNotFound: "Son yanıt modeli bulunamadı",
    noAnswerGenerated: "Yanıt oluşturulamadı",
    genericError: "Beklenmeyen bir hata oluştu",
  },
  connectionErrors: {
    apiTitle: "API Sunucusuna Bağlanılamıyor",
    apiDesc: "Open Notebook API sunucusuna ulaşılamadı",
    dbTitle: "Veritabanı Bağlantısı Başarısız",
    dbDesc: "API sunucusu çalışıyor ancak veritabanına erişilemiyor",
    troubleshooting: "Bu genellikle şu anlama gelir:",
    apiUnreachable1: "API sunucusu çalışmıyor",
    apiUnreachable2: "API sunucusu farklı bir adreste çalışıyor",
    apiUnreachable3: "Ağ bağlantısı sorunları",
    dbFailed1: "SurrealDB çalışmıyor",
    dbFailed2: "Veritabanı bağlantı ayarları hatalı",
    dbFailed3: "API ile veritabanı arasında ağ sorunları",
    quickFixes: "Hızlı çözümler:",
    setApiUrl: "API_URL ortam değişkenini ayarlayın:",
    checkSurreal: "SurrealDB'nin çalışıp çalışmadığını kontrol edin:",
    seeDocumentation: "Ayrıntılı kurulum talimatları için bakın:",
    docLink: "Open Notebook Belgeleri",
    showTechnical: "Teknik Ayrıntıları Göster",
    attemptedUrl: "Denenen URL",
    message: "Mesaj",
    technicalDetails: "Teknik Ayrıntılar",
    stackTrace: "Yığın İzi",
    retryLabel: "Bağlantıyı Yeniden Dene",
    retryHint: "Yeniden denemek için R tuşuna basın veya butona tıklayın",
    dockerLabel: "Docker için",
    localDevLabel: "Yerel geliştirme için",
  },
  auth: {
    loginTitle: "Open Notebook",
    loginDesc: "Uygulamaya erişmek için şifrenizi girin",
    passwordPlaceholder: "Şifre",
    signingIn: "Giriş yapılıyor...",
    signIn: "Giriş Yap",
    connectErrorHint: "Sunucuya bağlanılamıyor. API'nin çalışıp çalışmadığını kontrol edin.",
  },
  navigation: {
    collect: "Topla",
    process: "İşle",
    create: "Oluştur",
    manage: "Yönet",
    sources: "Kaynaklar",
    notebooks: "Defterler",
    askAndSearch: "Sor ve Ara",
    podcasts: "Podcastler",
    models: "Modeller",
    transformations: "Dönüşümler",
    transformation: "Dönüşüm",
    settings: "Ayarlar",
    advanced: "Gelişmiş",
    nav: "Gezinme",
    language: "Dili değiştir",
    theme: "Tema",
    ask: "Sor",
  },
  notebooks: {
    title: "Defterler",
    newNotebook: "Yeni Defter",
    searchPlaceholder: "Defterlerde ara...",
    archived: "Arşivlendi",
    archive: "Arşivle",
    unarchive: "Arşivden Çıkar",
    deleteNotebook: "Defteri Sil",
    deleteNotebookDesc: "\"{name}\" defterini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    deleteNotebookLoading: "Silme önizlemesi yükleniyor...",
    deleteNotebookNotes: "{count} not kalıcı olarak silinecek.",
    deleteNotebookNoNotes: "Silinecek not yok.",
    deleteNotebookExclusiveSources: "{count} kaynak yalnızca bu defterde bulunuyor.",
    deleteNotebookSharedSources: "{count} kaynak diğer defterlerle paylaşılıyor ve bağlantısı kesilecek.",
    deleteNotebookNoSources: "Bu defterde kaynak yok.",
    deleteExclusiveSourcesLabel: "Özel kaynakları sil",
    keepExclusiveSourcesLabel: "Bağlantıyı kes ve sakla",
    activeNotebooks: "Aktif Defterler",
    archivedNotebooks: "Arşivlenmiş Defterler",
    tileView: "Döşeme görünümü",
    listView: "Liste görünümü",
    notFound: "Defter bulunamadı",
    notFoundDesc: "İstenen defter mevcut değil.",
    updated: "Güncellendi",
    namePlaceholder: "Defter adı",
    addDescription: "Açıklama ekle...",
    noNotesYet: "Henüz not yok",
    deleteNote: "Notu Sil",
    deleteNoteConfirm: "Bu notu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    noteCreatedSuccess: "Not başarıyla oluşturuldu",
    failedToCreateNote: "Not oluşturulamadı",
    noteUpdatedSuccess: "Not başarıyla güncellendi",
    failedToUpdateNote: "Not güncellenemedi",
    noteDeletedSuccess: "Not başarıyla silindi",
    failedToDeleteNote: "Not silinemedi",
    createNew: "Yeni Defter Oluştur",
    createNewDesc: "Başlamak için bir ad ve isteğe bağlı açıklama girin.",
    descPlaceholder: "Bu defter hakkında daha fazla bilgi ekleyin...",
    createSuccess: "Defter başarıyla oluşturuldu",
    updateSuccess: "Defter başarıyla güncellendi",
    deleteSuccess: "Defter başarıyla silindi",
    recentlyViewed: "Son Görüntülenenler",
    toggleRecentlyViewed: "Son görüntülenenleri aç/kapat",
    recentlyViewedNotebook: "Defter",
    recentlyViewedSource: "Kaynak",
    lastViewed: "{{time}} görüntülendi",
  },
  sources: {
    bulkContext: "Bağlam",
    includeAllInContext: "Tümünü bağlama dahil et",
    includeAllInsights: "Tümünü dahil et (yalnızca içgörüler)",
    includeAllFull: "Tümünü dahil et (tam içerik)",
    excludeAllFromContext: "Tümünü bağlamdan çıkar",
    title: "Kaynaklar",
    add: "Kaynak Ekle",
    addNew: "Yeni Kaynak Ekle",
    addExisting: "Mevcut Kaynak Ekle",
    delete: "Kaynağı Sil",
    statusPreparing: "Hazırlanıyor",
    statusQueued: "Kuyrukta",
    statusProcessing: "İşleniyor",
    statusCompleted: "Tamamlandı",
    statusFailed: "Başarısız",
    statusPreparingDesc: "İşlemeye hazırlanıyor",
    statusQueuedDesc: "İşlenmeyi bekliyor",
    statusProcessingDesc: "İşleniyor",
    statusCompletedDesc: "Başarıyla işlendi",
    statusFailedDesc: "İşleme başarısız",
    failedToLoad: "Kaynaklar yüklenemedi",
    allSourcesDesc: "Tüm kaynaklarınızı burada görüntüleyin. Yeni kaynaklar ekleyebilir veya mevcut olanları yönetebilirsiniz.",
    allSources: "Tüm Kaynaklar",
    insights: "İçgörüler",
    yes: "Evet",
    no: "Hayır",
    loadingMore: "Daha fazla yükleniyor...",
    noSourcesYet: "Henüz kaynak yok",
    allSourcesDescShort: "Tüm kaynaklarınızı burada görüntüleyin.",
    cannotSaveNoteNoNotebook: "Not kaydedilemiyor: defter kimliği mevcut değil",
    createFirstSource: "Bilgi tabanınızı oluşturmaya başlamak için ilk kaynağınızı ekleyin.",
    deleteSourceConfirm: "Bu kaynağı silmek istediğinizden emin misiniz?",
    deleteConfirm: "Bunu silmek istediğinizden emin misiniz?",
    deleteConfirmWithTitle: "\"{title}\" öğesini silmek istediğinizden emin misiniz?",
    deleteSuccess: "Kaynak başarıyla silindi. Not: Dosyayı depolamadan silmek için ayarlar sayfasında \"dosyayı sil\" seçeneğini etkinleştirmeniz gerekir.",
    failedToDelete: "Kaynak silinemedi",
    sourceQueued: "Kaynak Kuyruğa Eklendi",
    sourceQueuedDesc: "Kaynak arka planda işlenmek üzere gönderildi. İlerlemeyi kaynaklar listesinden takip edebilirsiniz.",
    sourceAddedSuccess: "Kaynak başarıyla eklendi",
    failedToAddSource: "Kaynak eklenemedi",
    sourceUpdatedSuccess: "Kaynak başarıyla güncellendi",
    failedToUpdateSource: "Kaynak güncellenemedi",
    sourceDeletedSuccess: "Kaynak başarıyla silindi",
    failedToDeleteSource: "Kaynak silinemedi",
    fileUploadedSuccess: "Dosya başarıyla yüklendi",
    failedToUploadFile: "Dosya yüklenemedi",
    sourceRequeued: "Kaynak Yeniden Kuyruğa Alındı",
    sourceRequeuedDesc: "Kaynak işlenmek üzere yeniden kuyruğa alındı.",
    failedToRetry: "Yeniden deneme başarısız",
    sourcesAddedToNotebook: "{count} kaynak deftere eklendi",
    failedToAddSourcesToNotebook: "Kaynaklar deftere eklenemedi",
    partialAddSuccess: "{success} kaynak eklendi, {failed} başarısız",
    sourceRemovedFromNotebook: "Kaynak defterden başarıyla kaldırıldı",
    failedToRemoveSourceFromNotebook: "Kaynak defterden kaldırılamadı",
    removeConfirm: "Bunu defterden kaldırmak istediğinizden emin misiniz?",
    checking: "Kontrol ediliyor...",
    untitledSource: "Başlıksız Kaynak",
    maxItems: "en fazla {count}",
    insightsCount: "{count} içgörü",
    details: "Ayrıntılar",
    detailsTitle: "Kaynak Ayrıntıları",
    content: "İçerik",
    metadata: "Meta Veri",
    type: {
      link: "Bağlantı",
      file: "Dosya",
      text: "Metin",
    },
    id: "Kaynak Kimliği",
    topics: "Konular",
    embedded: "Gömüldü",
    notEmbedded: "Gömülmedi",
    embedContent: "İçeriği Göm",
    embedding: "Gömülüyor...",
    alreadyEmbedded: "Zaten Gömüldü",
    downloadFile: "Dosyayı İndir",
    fileUnavailable: "Dosya mevcut değil",
    preparing: "Hazırlanıyor...",
    generateNewInsight: "Yeni İçgörü Oluştur",
    selectTransformation: "Bir dönüşüm seçin...",
    noInsightsYet: "Henüz içgörü yok",
    createFirstInsight: "Yukarıdaki dönüşümü kullanarak ilk içgörünüzü oluşturun",
    viewInsight: "İçgörüyü Görüntüle",
    deleteInsight: "İçgörüyü Sil",
    deleteInsightConfirm: "Bu içgörüyü silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    insightGenerationStarted: "İçgörü oluşturma başladı. Kısa süre içinde görünecek.",
    editNote: "Notu düzenle",
    createNote: "Not oluştur",
    addTitle: "Başlık ekle...",
    untitledNote: "Başlıksız Not",
    writeNotePlaceholder: "Not içeriğinizi buraya yazın...",
    saveNote: "Notu Kaydet",
    createNoteBtn: "Not Oluştur",
    createFirstNote: "İçgörüleri ve gözlemleri kaydetmek için ilk notunuzu oluşturun.",
    urlLabel: "URL(ler) *",
    fileLabel: "Dosya(lar) *",
    textContentLabel: "Metin İçeriği *",
    enterUrlsPlaceholder: "URL'leri her satıra bir tane giriniz\nhttps://ornek.com/makale1\nhttps://ornek.com/makale2",
    batchUrlHint: "Toplu içe aktarma için birden fazla URL yapıştırın (her satıra bir tane)",
    invalidUrlsDetected: "Geçersiz URL'ler tespit edildi:",
    lineLabel: "Satır {line}",
    fixInvalidUrls: "Devam etmek için geçersiz URL'leri düzeltin veya kaldırın",
    selectMultipleFilesHint: "Toplu içe aktarma için birden fazla dosya seçin. Desteklenenler: Belgeler (PDF, DOC, DOCX, PPT, XLS, EPUB, TXT, MD), Medya (MP4, MP3, WAV, M4A), Görseller (JPG, PNG), Arşivler (ZIP)",
    selectedFiles: "Seçilen dosyalar:",
    textPlaceholder: "İçeriğinizi buraya yapıştırın veya yazın...",
    htmlDetected: "HTML içeriği tespit edildi. İşlendikten sonra Markdown'a dönüştürülecek.",
    titlePlaceholder: "Kaynağınıza açıklayıcı bir başlık verin",
    batchTitlesAuto: "Her kaynak için başlıklar otomatik olarak oluşturulacak.",
    batchCommonSettings: "Aynı defterler ve dönüşümler tüm öğelere uygulanacak.",
    urlsCount: "{count} URL",
    filesCount: "{count} dosya",
    addSource: "Kaynak Ekle",
    notEmbeddedAlert: "İçerik Gömülmedi",
    notEmbeddedDesc: "Bu içerik vektör araması için gömülmedi. Gömme, gelişmiş arama özelliklerini ve daha iyi içerik keşfini etkinleştirir.",
    openOnYoutube: "YouTube'da Aç",
    urlCopied: "URL panoya kopyalandı",
    viewSource: "Kaynağı Görüntüle",
    noInsightSelected: "İçgörü seçilmedi",
    sourceInsight: "Kaynak İçgörüsü",
    manageNotebooks: "Defterleri Yönet",
    manageNotebooksDesc: "Bu kaynağı içeren defterleri yönetin",
    noNotebooksAvailable: "Mevcut defter yok",
    loadFailed: "Kaynak ayrıntıları yüklenemedi",
    removeFromNotebook: "Defterden Kaldır",
    retryProcessing: "İşlemeyi Yeniden Dene",
    refreshContent: "İçeriği yenile",
    deleteSource: "Kaynağı Sil",
    retry: "Yeniden Dene",
    addExistingTitle: "Mevcut Kaynakları Ekle",
    addExistingDesc: "Mevcut defterlerinizdeki kaynakları seçerek mevcut deftere ekleyin.",
    searchPlaceholder: "Kaynakları ad veya URL ile arayın...",
    noNotebooksFound: "Defter bulunamadı.",
    showingFirst100: "İlk 100 kaynak gösteriliyor. Belirli olanları bulmak için arama yapın.",
    selectedCount: "{count} kaynak seçildi",
    added: "{date} tarihinde eklendi",
    addUrl: "URL Ekle",
    uploadFile: "Dosya Yükle",
    enterText: "Metin Girin",
    processDescription: "İçerik yapay zeka tarafından işlenecek ve analiz edilecek.",
    processingFiles: "Dosyalarınız işleniyor...",
    titleRequired: "Metin içeriği için başlık gereklidir",
    titleGenerated: "Boş bırakılırsa içerikten otomatik başlık oluşturulacak",
    batchCount: "{count} {type} işlenecek",
    enableEmbedding: "Arama için gömmeyi etkinleştir",
    embeddingDesc: "Bu kaynağın vektör aramalarında ve yapay zeka sorgularında bulunmasını sağlar",
    embeddingAlways: "Gömme otomatik etkinleştirildi",
    embeddingAlwaysDesc: "Ayarlarınız içeriği her zaman vektör araması için gömecek şekilde yapılandırılmış.",
    embeddingNever: "Gömme devre dışı",
    embeddingNeverDesc: "Ayarlarınız gömmeyi atlamak üzere yapılandırılmış. Bu kaynak için vektör arama kullanılamaz.",
    changeInSettings: "Bunu Ayarlar'dan değiştirebilirsiniz",
    notFound: "Kaynak bulunamadı",
    noContent: "İçerik mevcut değil",
    insightsDesc: "Model analizinden oluşturulan içgörüler",
    uploadedFile: "Yüklenen dosya",
    fileUnavailableDesc: "Bu dosya şu anda depolama sistemi nedeniyle mevcut değil.",
    batchSuccess: "{count} kaynak başarıyla oluşturuldu",
    batchFailed: "{count} kaynağın tamamı oluşturulamadı",
    batchPartial: "{success} başarılı, {failed} başarısız",
    submittingSource: "Kaynak işlenmek üzere gönderiliyor...",
    processingBatchSources: "{count} kaynak işleniyor. Bu birkaç dakika sürebilir.",
    processingSource: "Kaynağınız işleniyor. Bu birkaç dakika sürebilir.",
    maxFilesAllowed: "Toplu işlem başına en fazla {count} dosya",
  },
  chat: {
    sessions: "Oturumlar",
    sessionTitlePlaceholder: "Buraya bir başlık yazın...",
    noSessions: "Henüz sohbet oturumu yok",
    deleteSession: "Oturumu Sil",
    deleteSessionDesc: "Bu sohbet oturumunu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    sendPlaceholder: "Kaynaklarınız hakkında herhangi bir şey sorun...",
    sessionsTitle: "Sohbet Oturumları",
    chatWith: "{name} ile sohbet et",
    startConversation: "Bu {type} hakkında sohbet başlatın",
    askQuestions: "İçeriği daha iyi anlamak için sorular sorun",
    pressToSend: "Göndermek için {key} tuşuna basın",
    model: "Model",
    createToStart: "Başlamak için bir oturum oluşturun.",
    chatWithNotebook: "Defter ile Sohbet Et",
    unableToLoadChat: "Sohbet yüklenemedi",
    noDescription: "Açıklama yok",
    startByCreating: "Araştırmanızı düzenlemek için ilk defterinizi oluşturun.",
    messagesCount: "{count} mesaj",
    sessionCreated: "Sohbet oturumu oluşturuldu",
    sessionUpdated: "Oturum güncellendi",
    sessionDeleted: "Oturum silindi",
  },
  searchPage: {
    askAndSearch: "Sor ve Ara",
    chooseAMode: "Bir mod seçin",
    askBeta: "Sor (beta)",
    search: "Ara",
    askYourKb: "Bilgi Tabanınıza Sorun (beta)",
    askYourKbDesc: "Yapay zeka, bilgi tabanınızdaki belgelere dayanarak sorunuzu yanıtlayacak.",
    question: "Soru",
    enterQuestionPlaceholder: "Sorunuzu girin...",
    pressToSubmit: "Göndermek için Cmd/Ctrl+Enter tuşuna basın",
    noEmbeddingModel: "Seçili bir gömme modeliniz olmadığı için bu özelliği kullanamazsınız. Lütfen Modeller sayfasında bir tane ayarlayın.",
    usingCustomModels: "Özel Modeller Kullanılıyor",
    usingDefaultModels: "Varsayılan Modeller Kullanılıyor",
    advanced: "Gelişmiş",
    strategy: "Strateji",
    answer: "Yanıt",
    final: "Son",
    ask: "Sor",
    processing: "İşleniyor...",
    saveToNotebooks: "Defterlere Kaydet",
    searchDesc: "Bilgi tabanınızda belirli anahtar kelimeler veya kavramlar arayın",
    enterSearchPlaceholder: "Arama sorgusunu girin...",
    pressToSearch: "Aramak için Enter tuşuna basın",
    searchType: "Arama Türü",
    vectorSearchWarning: "Vektör araması için gömme modeli gereklidir. Yalnızca metin araması kullanılabilir.",
    textSearch: "Metin Araması",
    vectorSearch: "Vektör Araması",
    searchIn: "Şurada Ara",
    searchSources: "Kaynaklarda Ara",
    searchNotes: "Notlarda Ara",
    resultsFound: "{count} sonuç bulundu",
    matches: "Eşleşmeler ({count})",
    noResultsFor: "“{query}” için sonuç bulunamadı",
    notSet: "Ayarlanmadı",
    saveToNotebook: "Deftere Kaydet",
    saveSuccess: "Deftere başarıyla kaydedildi",
    saveError: "Deftere kaydedilemedi",
    selectNotebook: "Defter Seçin",
    searchAndAsk: "Ara ve Sor",
    searchResultsFor: "“{query}” için arama sonuçları",
    askAbout: "“{query}” hakkında sor",
    orSearchKb: "Veya bilgi tabanınızda arayın",
    saving: "Kaydediliyor...",
    advancedModelTitle: "Gelişmiş Model Seçimi",
    advancedModelDesc: "Sorgulama sürecinin her aşaması için belirli modeller seçin",
    strategyModel: "Strateji Modeli",
    answerModel: "Yanıt Modeli",
    finalAnswerModel: "Son Yanıt Modeli",
    selectStrategyPlaceholder: "Strateji modeli seçin",
    selectAnswerPlaceholder: "Yanıt modeli seçin",
    selectFinalPlaceholder: "Son yanıt modeli seçin",
    saveChanges: "Değişiklikleri Kaydet",
    processingQuestion: "Sorunuz işleniyor...",
  },
  podcasts: {
    generateEpisode: "Podcast Bölümü Oluştur",
    generateEpisodeDesc: "Yeni bir podcast bölümü oluşturmadan önce dahil edilecek içeriği seçin ve bölüm ayrıntılarını yapılandırın.",
    content: "İçerik",
    contentDesc: "Bu bölüme dahil edilecek defterleri, kaynakları ve notları seçin.",
    itemsSelected: "{count} öğe seçildi",
    tokens: "{count} token",
    chars: "{count} karakter",
    loadingNotebooks: "Defterler yükleniyor...",
    noNotebooksFoundInPodcasts: "Defter bulunamadı. Podcast oluşturmadan önce bir defter oluşturun ve içerik ekleyin.",
    noContentSelected: "İçerik seçilmedi",
    summary: "Özet",
    fullContent: "Tam içerik",
    untitledSource: "Başlıksız kaynak",
    untitledNote: "Başlıksız not",
    episodeSettings: "Bölüm Ayarları",
    episodeProfile: "Bölüm profili",
    episodeProfilePlaceholder: "Bir bölüm profili seçin",
    episodeName: "Bölüm adı",
    episodeNamePlaceholder: "örn. Yapay Zeka ve İşin Geleceği",
    additionalInstructions: "Ek talimatlar",
    instructionsPlaceholder: "Bölüm brifingine eklenecek ek tavsiyeler...",
    generating: "Oluşturuluyor...",
    generate: "Oluştur",
    hostPlaceholder: "Sunucu {number}",
    profileRequired: "Bölüm Profili Gerekli",
    profileRequiredDesc: "Podcast oluşturmadan önce bir bölüm profili seçin.",
    nameRequired: "Bölüm adı gerekli",
    nameRequiredDesc: "Bölüm için bir ad girin.",
    addContext: "Bağlam ekle",
    addContextDesc: "Bölüme dahil etmek için en az bir kaynak veya not seçin.",
    generationFailed: "Podcast oluşturma başarısız",
    speakerProfile: "Konuşmacı Profili",
    usesSpeakerProfile: "Konuşmacı profili kullanır",
    sources: "Kaynaklar",
    notes: "Notlar",
    noSources: "Bu defterde kaynak yok.",
    noNotes: "Bu defterde not yok.",
    selectMode: "Mod seçin",
    buildContextFailed: "Bağlam oluşturulamadı. Lütfen seçimlerinizi gözden geçirin.",
    podcastTaskStarted: "Podcast görevi başlatıldı",
    loadingProfiles: "Bölüm profilleri yükleniyor...",
    noProfilesFound: "Bölüm profili bulunamadı. Podcast oluşturmadan önce bir bölüm profili oluşturun.",
    listTitle: "Podcastler",
    listDesc: "Oluşturulan bölümleri takip edin ve yeniden kullanılabilir profilleri yönetin.",
    chooseAView: "Bir görünüm seçin",
    episodesTab: "Bölümler",
    templatesTab: "Profiller",
    overviewTitle: "Bölümlere genel bakış",
    overviewDesc: "Podcast oluşturma işlerini izleyin ve son eserleri inceleyin.",
    generateBtn: "Podcast Oluştur",
    total: "Toplam",
    processingLabel: "İşleniyor",
    completedLabel: "Tamamlandı",
    failedLabel: "Başarısız",
    pendingLabel: "Beklemede",
    loadErrorTitle: "Bölümler yüklenemedi",
    loadErrorDesc: "En son podcast bölümleri alınamadı. Kısa süre sonra tekrar deneyin.",
    loadingEpisodes: "Bölümler yükleniyor…",
    noEpisodesYet: "Henüz podcast bölümü yok. Defter veya kaynak sohbet arayüzlerinden ilk bölümünüzü oluşturun.",
    statusRunningTitle: "Şu An İşleniyor",
    statusRunningDesc: "Aktif olarak içerik oluşturan bölümler.",
    statusPendingTitle: "Kuyrukta / Beklemede",
    statusPendingDesc: "İşleme başlamayı bekleyen gönderilmiş bölümler.",
    statusCompletedTitle: "Tamamlanan Bölümler",
    statusCompletedDesc: "İncelemeye, indirmeye veya yayınlamaya hazır.",
    statusFailedTitle: "Başarısız Bölümler",
    statusFailedDesc: "Oluşturma sırasında sorunla karşılaşan bölümler.",
    templatesWorkspaceTitle: "Profiller çalışma alanı",
    templatesWorkspaceDesc: "Hızlı podcast üretimi için yeniden kullanılabilir bölüm ve konuşmacı yapılandırmaları oluşturun.",
    howTemplatesPowerTitle: "Profiller podcast oluşturmayı nasıl destekler",
    howTemplatesPowerDesc: "Profiller podcast iş akışını iki yeniden kullanılabilir yapı taşına böler. Yeni bir bölüm oluştururken istediğiniz gibi birleştirin.",
    episodeProfilesSetFormat: "Bölüm profilleri formatı belirler",
    episodeProfilesList1: "Segment sayısını ve hikaye akışını ana hatlarıyla belirtin",
    episodeProfilesList2: "Brifing, ana hat ve senaryo yazımı için kullanılan dil modellerini seçin",
    episodeProfilesList3: "Her bölümün tutarlı bir tonla başlaması için varsayılan brifingleri saklayın",
    speakerProfilesBringVoices: "Konuşmacı profilleri sesleri hayata geçirir",
    speakerProfilesList1: "Metinden sese sağlayıcısını ve modelini seçin",
    speakerProfilesList2: "Her konuşmacı için kişilik, geçmiş ve telaffuz notlarını kaydedin",
    speakerProfilesList3: "Aynı ev sahibi veya konuk seslerini farklı bölüm formatlarında yeniden kullanın",
    recommendedWorkflow: "Önerilen iş akışı",
    workflowStep1: "İhtiyaç duyduğunuz her ses için konuşmacı profilleri oluşturun",
    workflowStep2: "Bu konuşmacılara ada göre atıfta bulunan bölüm profilleri oluşturun",
    workflowStep3: "Hikayeye uygun bölüm profilini seçerek podcast oluşturun",
    workflowHint: "Bölüm profilleri konuşmacı profillerine ada göre atıfta bulunur, bu nedenle konuşmacılarla başlamak daha sonra eksik ses atamalarını önler.",
    failedToLoadTemplates: "Profil verileri yüklenemedi",
    failedToLoadTemplatesDesc: "API'nin çalıştığından emin olun ve tekrar deneyin. Bazı bölümler eksik olabilir.",
    loadingTemplates: "Profiller yükleniyor…",
    speakerProfilesTitle: "Konuşmacı profilleri",
    speakerProfilesDesc: "Oluşturulan bölümler için sesleri ve kişilikleri yapılandırın.",
    createSpeaker: "Konuşmacı oluştur",
    noSpeakerProfiles: "Henüz konuşmacı profili yok. Bölüm profillerini kullanılabilir hale getirmek için bir tane oluşturun.",
    noDescription: "Açıklama sağlanmadı.",
    usedByCount_one: "1 bölüm tarafından kullanılıyor",
    usedByCount_other: "{count} bölüm tarafından kullanılıyor",
    usedByCount: "{count} bölüm tarafından kullanılıyor",
    unused: "Kullanılmıyor",
    voiceId: "Ses Kimliği",
    backstory: "Geçmiş",
    personality: "Kişilik",
    edit: "Düzenle",
    duplicate: "Çoğalt",
    deleteSpeakerProfileTitle: "Konuşmacı profili silinsin mi?",
    deleteSpeakerProfileDesc: "\"{name}\" silinmesi geri alınamaz.",
    deleteSpeakerDisabledHint: "Silmeden önce bu konuşmacıyı bölüm profillerinden kaldırın.",
    deleting: "Siliniyor…",
    episodeProfilesTitle: "Bölüm profilleri",
    episodeProfilesDesc: "Programlarınız için yeniden kullanılabilir oluşturma ayarlarını tanımlayın.",
    createProfile: "Profil oluştur",
    createSpeakerFirst: "Bölüm profili eklemeden önce bir konuşmacı profili oluşturun.",
    noEpisodeProfiles: "Henüz bölüm profili yok. Podcast oluşturmayı başlatmak için bir tane oluşturun.",
    speakerCreated: "Konuşmacı Oluşturuldu",
    speakerCreatedDesc: "\"{name}\" konuşmacısı başarıyla eklendi.",
    failedToCreateSpeaker: "Konuşmacı profili oluşturulamadı",
    speakerUpdated: "Konuşmacı Güncellendi",
    speakerUpdatedDesc: "\"{name}\" konuşmacısı başarıyla güncellendi.",
    failedToUpdateSpeaker: "Konuşmacı profili güncellenemedi",
    speakerDeleted: "Konuşmacı Silindi",
    speakerDeletedDesc: "\"{name}\" konuşmacısı başarıyla kaldırıldı.",
    failedToDeleteSpeaker: "Konuşmacı profili silinemedi",
    speakerDuplicated: "Konuşmacı Çoğaltıldı",
    speakerDuplicatedDesc: "\"{name}\" konuşmacısı başarıyla çoğaltıldı.",
    failedToDuplicateSpeaker: "Konuşmacı profili çoğaltılamadı",
    generationStarted: "Oluşturma Başladı",
    generationStartedDesc: "Podcast oluşturma kuyruğa alındı.",
    failedToStartGeneration: "Oluşturma başlatılamadı",
    tryAgainMoment: "Lütfen bir an sonra tekrar deneyin.",
    deleteProfileTitle: "Profil silinsin mi?",
    deleteProfileDesc: "Bu işlem \"{name}\" profilini kaldıracak. Mevcut bölümler verilerini korur, ancak yeni bölümler artık bu yapılandırmayı kullanmaz.",
    profileCreated: "Profil Oluşturuldu",
    profileCreatedDesc: "\"{name}\" bölüm profili başarıyla oluşturuldu.",
    failedToCreateProfile: "Profil oluşturulamadı",
    profileUpdated: "Profil Güncellendi",
    profileUpdatedDesc: "\"{name}\" bölüm profili başarıyla güncellendi.",
    failedToUpdateProfile: "Profil güncellenemedi",
    profileDeleted: "Profil Silindi",
    profileDeletedDesc: "\"{name}\" bölüm profili başarıyla kaldırıldı.",
    failedToDeleteProfile: "Profil silinemedi",
    failedToDeleteProfileDesc: "Bölüm profili kaldırılamadı.",
    profileDuplicated: "Profil Çoğaltıldı",
    profileDuplicatedDesc: "\"{name}\" bölüm profili başarıyla çoğaltıldı.",
    failedToDuplicateProfile: "Profil çoğaltılamadı",
    episodeDeleted: "Bölüm Silindi",
    episodeDeletedDesc: "Bölüm başarıyla silindi.",
    failedToDeleteEpisode: "Bölüm silinemedi",
    failedToDeleteSpeakerDesc: "Konuşmacı profili kaldırılamadı.",
    outlineModel: "Ana hat modeli",
    transcriptModel: "Transkript modeli",
    segments: "Segmentler",
    defaultBriefingTitle: "Varsayılan brifing",
    created: "{time} tarihinde oluşturuldu",
    details: "Ayrıntılar",
    summaryTab: "Özet",
    outlineTab: "Ana Hat",
    transcriptTab: "Transkript",
    briefing: "Brifing",
    noOutline: "Ana hat mevcut değil.",
    noTranscript: "Transkript mevcut değil.",
    deleteEpisodeTitle: "Bölüm silinsin mi?",
    deleteEpisodeDesc: "Bu işlem \"{name}\" ve ses dosyasını kalıcı olarak kaldıracak.",
    audioUnavailable: "Ses mevcut değil",
    segment: "Segment",
    speaker: "Konuşmacı",
    profile: "Profil",
    link: "Bağlantı",
    file: "Dosya",
    embedded: "Gömüldü",
    notEmbedded: "Gömülmedi",
    noSpeakerProfilesAvailable: "Kullanılabilir konuşmacı profili yok",
    editEpisodeProfile: "Bölüm Profilini Düzenle",
    createEpisodeProfile: "Bölüm Profili Oluştur",
    episodeProfileFormDesc: "Bölümlerin nasıl oluşturulacağını ve varsayılan olarak hangi konuşmacı yapılandırmasını kullanacağını tanımlayın.",
    noSpeakerProfilesDesc: "Bir bölüm profili yapılandırmadan önce konuşmacı profili oluşturun.",
    profileName: "Profil adı",
    profileNamePlaceholder: "örn. Teknoloji tartışması",
    descriptionPlaceholder: "Bu profilin ne zaman kullanılacağına dair kısa özet",
    speakerConfig: "Konuşmacı yapılandırması",
    selectSpeakerProfile: "Bir konuşmacı profili seçin",
    outlineGeneration: "Ana hat oluşturma",
    transcriptGeneration: "Transkript oluşturma",
    defaultBriefingPlaceholder: "Bu bölüm formatının yapısını, tonunu ve hedeflerini ana hatlarıyla belirtin",
    editSpeakerProfile: "Konuşmacı Profilini Düzenle",
    createSpeakerProfile: "Konuşmacı Profili Oluştur",
    speakerProfileFormDesc: "Metinden sese ayarlarını yapılandırın ve dört adede kadar konuşmacı tanımlayın.",
    speakers: "Konuşmacılar",
    speakersDesc: "Bu profil için bir ila dört ses yapılandırın.",
    addSpeaker: "Konuşmacı ekle",
    speakerNumber: "Konuşmacı {number}",
    backstoryPlaceholder: "Konuşmacı için kısa biyografi veya bağlam",
    personalityPlaceholder: "Üslup ve tonu tanımlayın",
    outlineModelRequired: "Ana hat modeli gereklidir",
    transcriptModelRequired: "Transkript modeli gereklidir",
    defaultBriefingRequired: "Varsayılan brifing gereklidir",
    segmentsInteger: "Tam sayı olmalıdır",
    segmentsMin: "En az 3 segment",
    segmentsMax: "En fazla 20 segment",
    voiceIdRequired: "Ses kimliği gereklidir",
    backstoryRequired: "Geçmiş gereklidir",
    personalityRequired: "Kişilik gereklidir",
    speakerCountMin: "En az bir konuşmacı gereklidir",
    speakerCountMax: "En fazla 4 konuşmacı yapılandırabilirsiniz",
    delete: "Sil",
    failedToDelete: "Podcast silinemedi",
    retry: "Yeniden Dene",
    retrying: "Yeniden deneniyor…",
    retryStarted: "Yeniden Deneme Başladı",
    retryStartedDesc: "Yeni bir podcast oluşturma işi gönderildi.",
    failedToRetry: "Bölüm yeniden denenemedi",
    errorDetails: "Hata ayrıntıları",
    language: "Dil",
    languagePlaceholder: "Bir dil seçin (isteğe bağlı)",
    podcastLanguage: "Podcast dili",
    selectOutlineModel: "Ana hat modeli seçin",
    selectTranscriptModel: "Transkript modeli seçin",
    voiceModel: "Ses modeli",
    voiceModelRequired: "Ses modeli gereklidir",
    selectVoiceModel: "Ses modeli seçin",
    perSpeakerTtsOverride: "Konuşmacı başına TTS geçersiz kılma (isteğe bağlı)",
    useProfileDefault: "Profil varsayılanını kullan",
    setupRequired: "Kurulum gerekli",
    setupRequiredDesc: "Bazı profillerin henüz yapılandırılmış modeli yok. Podcast oluşturmadan önce düzenleyip model seçin.",
    notConfigured: "Yapılandırılmadı",
  },
  settings: {
    contentProcessing: "İçerik İşleme",
    contentProcessingDesc: "Belgeler ve URL'lerin nasıl işleneceğini yapılandırın",
    docEngine: "Belge İşleme Motoru",
    docEnginePlaceholder: "Belge işleme motoru seçin",
    urlEngine: "URL İşleme Motoru",
    urlEnginePlaceholder: "URL işleme motoru seçin",
    autoRecommended: "Otomatik (Önerilen)",
    simple: "Basit",
    docling: "Docling",
    helpMeChoose: "Seçmeme yardım et",
    docHelp: "· Docling biraz daha yavaştır ancak özellikle tablolar ve görseller içeren belgeler için daha doğrudur. · Basit, belgeden herhangi bir içeriği formatlamadan çıkaracak. · Otomatik (önerilen) docling üzerinden işlemeyi deneyecek ve basit'e geri dönecek.",
    firecrawl: "Firecrawl",
    jina: "Jina",
    urlHelp: "· Firecrawl ücretli bir hizmettir (ücretsiz katmanı ile) ve çok güçlüdür. · Jina da iyi bir seçenektir ve ücretsiz katmanı vardır. · Basit, temel HTTP çıkarımını kullanır ve JavaScript tabanlı web sitelerindeki içerikleri kaçırır. · Otomatik (önerilen) önce firecrawl, sonra Jina'yı dener ve son olarak basit'e geri döner.",
    embeddingAndSearch: "Gömme ve Arama",
    embeddingAndSearchDesc: "Arama ve gömme seçeneklerini yapılandırın",
    defaultEmbeddingOption: "Varsayılan Gömme Seçeneği",
    embeddingOptionPlaceholder: "Gömme seçeneği seçin",
    ask: "Sor",
    always: "Her Zaman",
    never: "Hiçbir Zaman",
    embeddingHelp: "İçeriği gömmek, sizin ve yapay zeka ajanlarınızın bulmayı kolaylaştırır. Yerel bir gömme modeli çalıştırıyorsanız (örn. Ollama), maliyet konusunda endişelenmenize gerek yok ve her şeyi gömebilirsiniz.",
    fileManagement: "Dosya Yönetimi",
    fileManagementDesc: "Dosya işleme ve depolama seçeneklerini yapılandırın",
    autoDeleteFiles: "Dosyaları Otomatik Sil",
    autoDeletePlaceholder: "Otomatik silme seçeneği seçin",
    filesHelp: "Dosyalarınız yüklenip işlendikten sonra artık gerekli değildir. Çoğu kullanıcı Open Notebook'un yüklenen dosyaları yükleme klasöründen otomatik olarak silmesine izin vermelidir.",
    loadFailed: "Ayarlar yüklenemedi",
  },
  advanced: {
    title: "Gelişmiş Araçlar",
    desc: "Uzman kullanıcılar için gelişmiş araçlar ve yardımcı programlar",
    systemInfo: "Sistem Bilgisi",
    rebuildEmbeddings: "Gömmeleri Yeniden Oluştur",
    rebuildEmbeddingsDesc: "Tüm kaynaklar için vektör arama indeksini yeniden oluştur",
    currentVersion: "Mevcut Sürüm",
    latestVersion: "Son Sürüm",
    status: "Durum",
    updateAvailable: "Sürüm {version} Mevcut",
    updateAvailableDesc: "Open Notebook'un yeni bir sürümü mevcut.",
    upToDate: "Güncel",
    unknown: "Bilinmiyor",
    viewOnGithub: "GitHub'da Görüntüle",
    updateCheckFailed: "Güncellemeler kontrol edilemiyor. GitHub'a ulaşılamıyor olabilir.",
    rebuild: {
      mode: "Yeniden Oluşturma Modu",
      existing: "Mevcut",
      all: "Tümü",
      existingDesc: "Yalnızca zaten gömülmüş öğeleri yeniden göm (daha hızlı, model değiştirme için)",
      allDesc: "Mevcut öğeleri yeniden göm + gömme olmayan öğeler için gömme oluştur (daha yavaş, kapsamlı)",
      include: "Yeniden Oluşturmaya Dahil Et",
      selectOneError: "Lütfen yeniden oluşturmak için en az bir öğe türü seçin",
      starting: "Yeniden Oluşturma Başlatılıyor...",
      startBtn: "🚀 Yeniden Oluşturmayı Başlat",
      queued: "Kuyruğa Alındı",
      running: "İşler gönderiliyor...",
      completed: "İşler Gönderildi!",
      failed: "Başarısız",
      leavePageHint: "Bu sayfadan ayrılabilirsiniz, arka planda çalışmaya devam edecek",
      startNew: "Yeni Yeniden Oluşturma Başlat",
      itemsProcessed: "{processed}/{total} iş gönderildi (%{percent})",
      failedItems: "{count} iş gönderilemedi",
      time: "Süre",
      whenToRebuild: "Gömmeleri ne zaman yeniden oluşturmalıyım?",
      whenToRebuildAns: "Model değiştirirken, sürüm yükseltirken, bozulmayı düzeltirken veya toplu içe aktarmadan sonra yeniden oluşturmalısınız.",
      howLong: "Yeniden oluşturma ne kadar sürer?",
      howLongAns: "İşlem süresi öğe sayısına, model hızına ve API hız sınırlarına bağlıdır. Yerel modeller genellikle çok hızlıdır.",
      isSafe: "Uygulamayı kullanırken yeniden oluşturmak güvenli mi?",
      isSafeAns: "Evet, yeniden oluşturmak güvenlidir! İçeriği silmez, yalnızca gömmeleri değiştirir ve hataları zarif şekilde işler.",
    },
  },
  transformations: {
    title: "Dönüşümler",
    desc: "Dönüşümler, yapay zekanın bir kaynağı işlemek ve içgörüler, özetler vb. çıkarmak için kullanacağı istemllerdir.",
    workspace: "Çalışma alanı seçin",
    playground: "Oyun Alanı",
    defaultPrompt: "Varsayılan Dönüşüm İstemi",
    defaultPromptDesc: "Bu, tüm dönüşüm istemlerinize eklenecek",
    defaultPromptPlaceholder: "Varsayılan dönüşüm talimatlarınızı girin...",
    listTitle: "Özel Dönüşümler",
    createNew: "Yeni Oluştur",
    inputLabel: "Giriş Metni",
    inputPlaceholder: "Dönüştürmek için metin girin...",
    outputLabel: "Çıktı",
    runTest: "Dönüşümü Çalıştır",
    running: "Çalışıyor...",
    selectToStart: "Başlamak için bir dönüşüm seçin",
    name: "Ad",
    namePlaceholder: "Benzersiz tanımlayıcı, örn. anahtar_konular",
    titlePlaceholder: "Görüntülenen başlık, varsayılan olarak ad",
    promptPlaceholder: "Bu dönüşümü destekleyecek istemi yazın...",
    descriptionPlaceholder: "Bu dönüşümün ne yaptığını açıklayın.",
    suggestDefault: "Yeni kaynaklarda varsayılan olarak öner",
    promptHint: "İstemler kaynak içeriği göz önünde bulundurularak yazılmalıdır. Modelden özetleme, içgörü çıkarma veya tablolar gibi yapılandırılmış çıktılar üretmesini isteyebilirsiniz.",
    createSuccess: "Dönüşüm başarıyla oluşturuldu",
    updateSuccess: "Dönüşüm başarıyla güncellendi",
    deleteSuccess: "Dönüşüm başarıyla silindi",
    noTransformations: "Henüz dönüşüm yok",
    createOne: "Başlamak için bir dönüşüm oluşturun",
    selectModel: "Model seçin",
    deleteConfirm: "Bu dönüşümü silmek istediğinizden emin misiniz?",
    model: "Model",
    systemPrompt: "Sistem İstemi",
    overrideModelDesc: "Bu sohbet oturumu için varsayılan modeli geçersiz kılın. Sistem varsayılanını kullanmak için boş bırakın.",
    sessionUseReplacement: "Bu oturum varsayılan model yerine {name} kullanacak.",
    systemDefault: "Sistem Varsayılanı",
  },
  models: {
    embedding: "Gömme Modelleri",
    tts: "Metinden Sese (TTS)",
    stt: "Sesten Metne (STT)",
    apiKey: "API Anahtarı",
    deleteSuccess: "Model başarıyla silindi",
    saveSuccess: "Model başarıyla kaydedildi",
    noModels: "Model yok",
    discoverModels: "Modelleri Keşfet",
    noModelsFound: "Bu sağlayıcıdan model bulunamadı",
    modelType: "Model Türü",
    modelTypeHint: "Eklemek istediğiniz modellerin türünü seçin. Farklı türlere ihtiyaç duyuyorsanız, ayrı toplu işlemler halinde ekleyin.",
    deleteModel: "Modeli Sil",
    defaultAssignments: "Varsayılan Model Atamaları",
    defaultAssignmentsDesc: "Open Notebook genelinde farklı amaçlar için hangi modellerin kullanılacağını yapılandırın",
    missingRequiredModels: "Eksik gerekli modeller: {models}. Bu modeller olmadan Open Notebook düzgün çalışmayabilir.",
    selectModelPlaceholder: "Model seçin",
    requiredModelPlaceholder: "⚠️ Gerekli - Model seçin",
    chatModelLabel: "Sohbet Modeli",
    chatModelDesc: "Sohbet konuşmaları için kullanılır",
    transformationModelLabel: "Dönüşüm Modeli",
    transformationModelDesc: "Özetler, içgörüler ve dönüşümler için kullanılır",
    toolsModelLabel: "Araçlar Modeli",
    toolsModelDesc: "Fonksiyon çağırma için kullanılır - OpenAI veya Anthropic önerilir",
    largeContextModelLabel: "Büyük Bağlam Modeli",
    largeContextModelDesc: "Büyük belgeleri işlemek için kullanılır - Gemini önerilir",
    embeddingModelLabel: "Gömme Modeli",
    embeddingModelDesc: "Anlamsal arama ve vektör gömme için kullanılır",
    ttsModelLabel: "Metinden Sese Modeli",
    ttsModelDesc: "Podcast oluşturma için kullanılır",
    sttModelLabel: "Sesten Metne Modeli",
    sttModelDesc: "Ses transkripsiyonu için kullanılır",
    embeddingChangeTitle: "Gömme Modeli Değişikliği",
    embeddingChangeConfirm: "Gömme modelinizi {from}'dan {to}'ya değiştirmek üzeresiniz.",
    rebuildRequired: "Önemli: Yeniden Oluşturma Gerekli",
    rebuildReason: "Gömme modelinizi değiştirmek, tutarlılığı korumak için mevcut tüm gömmelerin yeniden oluşturulmasını gerektirir. Yeniden oluşturmadan aramalarınız yanlış veya eksik sonuçlar döndürebilir.",
    whatHappensNext: "Bundan sonra ne olacak:",
    step1: "Varsayılan gömme modeliniz güncellenecek",
    step2: "Mevcut gömmeler yeniden oluşturulana kadar değişmeyecek",
    step3: "Yeni içerik yeni gömme modelini kullanacak",
    step4: "Gömmeleri mümkün olan en kısa sürede yeniden oluşturmalısınız",
    proceedToRebuildPrompt: "Şimdi yeniden oluşturmayı başlatmak için Gelişmiş sayfasına gitmek ister misiniz?",
    changeModelOnly: "Yalnızca Modeli Değiştir",
    changeAndRebuild: "Değiştir ve Yeniden Oluşturmaya Git",
    autoAssign: "Varsayılanları Otomatik Ata",
    autoAssigning: "Atanıyor...",
    autoAssignSuccess: "{count} varsayılan model otomatik atandı",
    autoAssignNoModels: "Atanacak model yok. Lütfen önce modelleri senkronize edin.",
    autoAssignAlreadySet: "Tüm varsayılan modeller zaten yapılandırılmış",
    testModel: "Modeli Test Et",
    testModelSuccess: "Model Testi Başarılı",
    testModelFailed: "Model Testi Başarısız",
    searchOrAddModel: "Model adı arayın veya yazın...",
    addCustomModel: "\"{name}\" Ekle",
  },
  apiKeys: {
    title: "Yapay zekanızı kendi API anahtarlarınızla yapılandırın",
    description: "Open Notebook'ta yapay zeka sağlayıcılarını etkinleştirmek için API anahtarlarını güvenli şekilde veritabanında saklayın.",
    encryptionRequired: "Şifreleme anahtarı yapılandırılmadı",
    encryptionRequiredDescription: "Veritabanında API anahtarlarının saklanmasını etkinleştirmek için OPEN_NOTEBOOK_ENCRYPTION_KEY ortam değişkenini herhangi bir gizli dize olarak ayarlayın.",
    configured: "Yapılandırıldı",
    notConfigured: "Yapılandırılmadı",
    migrationAvailable: "Ortam Değişkenleri Tespit Edildi",
    migrationDescription: "{count} API anahtarı ortam değişkenleri aracılığıyla yapılandırılmış ve daha kolay yönetim için veritabanına taşınabilir.",
    migrateToDatabase: "Veritabanına Taşı",
    migrating: "Taşınıyor...",
    migrationSuccess: "{count} API anahtarı başarıyla taşındı",
    migrationErrors: "{count} anahtar taşınamadı",
    migrationNothingToMigrate: "Tüm anahtarlar zaten veritabanında",
    learnMore: "API anahtarlarını nasıl yapılandıracağınızı öğrenin →",
    testConnection: "Bağlantıyı Test Et",
    testSuccess: "Bağlantı başarılı",
    testFailed: "Bağlantı testi başarısız",
    syncModels: "Modelleri Senkronize Et",
    syncSuccess: "{discovered} model keşfedildi, {new} yeni eklendi",
    syncNoNew: "{count} model keşfedildi, tamamı zaten kayıtlı",
    syncFailed: "Modeller senkronize edilemedi",
    getApiKey: "API Anahtarı Al",
    vertexProject: "GCP Proje Kimliği",
    vertexLocation: "Bölge",
    vertexCredentials: "Hizmet Hesabı JSON Yolu",
    addConfig: "Yapılandırma Ekle",
    editConfig: "Yapılandırmayı Düzenle",
    deleteConfig: "Yapılandırmayı Sil",
    configName: "Yapılandırma Adı",
    configNameHint: "Bu yapılandırma için açıklayıcı bir ad (örn. 'Üretim', 'Geliştirme')",
    baseUrl: "Temel URL",
    baseUrlOverrideHint: "Yalnızca sağlayıcının varsayılan API uç noktasını geçersiz kılmanız gerekiyorsa değiştirin.",
    numCtx: "Bağlam Penceresi (num_ctx)",
    numCtxHint: "Ollama modelleri için maksimum bağlam penceresi. Varsayılanı kullanmak için boş bırakın (8192). Yalnızca donanımınız daha büyük pencereyi kaldırabiliyorsa artırın.",
    deleteConfigConfirm: "'{name}' yapılandırmasını silmek istediğinizden emin misiniz? Bu geri alınamaz.",
    configSaveSuccess: "Yapılandırma başarıyla kaydedildi",
    configUpdateSuccess: "Yapılandırma başarıyla güncellendi",
    configDeleteSuccess: "Yapılandırma başarıyla silindi",
    apiKeyEditHint: "Mevcut API anahtarını korumak için boş bırakın",
    decryptionError: "Şifre Çözme Hatası",
    decryptionErrorDescription: "Bu kimlik bilgisinin API anahtarı çözülemedi. Şifreleme anahtarı değişmiş olabilir. Bu kimlik bilgisini silin ve doğru anahtarla yeniden oluşturun.",
  },
  setupBanner: {
    encryptionRequired: "Şifreleme anahtarı yapılandırılmadı",
    encryptionRequiredDescription: "Güvenli kimlik bilgisi depolamayı etkinleştirmek için OPEN_NOTEBOOK_ENCRYPTION_KEY ortam değişkenini ayarlayın.",
    migrationAvailable: "API anahtarı taşıma mevcut",
    migrationDescription: "{count} sağlayıcının API anahtarları ortam değişkenleri aracılığıyla ayarlanmış. Daha kolay yönetim için veritabanına taşıyın.",
    goToSettings: "Ayarlara Git",
    viewDocs: "Belgeleri Görüntüle",
  },
}
